import { render, staticRenderFns } from "./TariffPackets.vue?vue&type=template&id=577b9a00&scoped=true"
import script from "./TariffPackets.vue?vue&type=script&lang=js"
export * from "./TariffPackets.vue?vue&type=script&lang=js"
import style0 from "./TariffPackets.vue?vue&type=style&index=0&id=577b9a00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577b9a00",
  null
  
)

export default component.exports